import { GetLocalState } from "Connectivity/LocalStorage";

const ImageReplacer = (path: string) => {
  
  const settings = GetLocalState("settings");
  
  if (!settings.client.useCompression) {
    return path;
  }

  const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
  const hasImageExtension = imageExtensions.some(ext => path.toLowerCase().endsWith(ext));
  
  return hasImageExtension ? `${path}.webp` : path;

}

export default ImageReplacer;